import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ISubscriberRequest, IThankingPopupInputs } from '@shared/interfaces';
import { emailValidator } from '@shared/utils';

import { SnackbarService } from '../../../../../services/snackbar.service';
import { PublicSubscribersService } from '../../services/public-subscriber.service';
import { ThankingPopupComponent } from '../thanking-popup/thanking-popup.component';

@Component({
  selector: 'el-newsletter-popup',
  templateUrl: './newsletter-popup.component.html',
  styleUrls: ['./newsletter-popup.component.scss'],
})
export class NewsLetterPopupComponent {
  data: IThankingPopupInputs;

  newsletterForm = new FormGroup({
    email: new FormControl<string>(null, [
      Validators.required,
      emailValidator(),
    ]),
  });

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<NewsLetterPopupComponent>,
    public translate: TranslateService,
    private snackBar: SnackbarService,
    private matDialog: MatDialog,
    private publicSubscriberService: PublicSubscribersService
  ) {}

  onReturn() {
    this.dialogRef.close();
    this.router.navigate([this.router.url]);
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.newsletterForm.valid) {
      this.data = {
        title: this.translate.instant('static.pop-ups.thanking-popup.topic'),
        sub_title: this.translate.instant(
          'static.pop-ups.thanking-popup.description'
        ),
      };

      const subscriber: ISubscriberRequest = {
        email: this.newsletterForm.controls.email.value,
      };

      this.publicSubscriberService.createSubscriber(subscriber).subscribe({
        next: (response) => {
          if (response.success) {
            this.dialogRef.close();
            this.matDialog.open(ThankingPopupComponent, {
              maxWidth: '800px',
              width: '100%',
              maxHeight: '100vh',
              data: this.data,
            });
          } else {
            this.dialogRef.close();
          }
        },
      });
    } else if (this.newsletterForm.controls.email.hasError('duplicate')) {
      this.snackBar.error(
        this.translate.instant('static.pop-ups.email-duplicate-error')
      );
    } else {
      this.snackBar.error(
        this.translate.instant('static.pop-ups.form-error-message')
      );
    }
  }
  onEmailInput(event: Event) {
    const email = (event.target as HTMLInputElement).value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const isValid = emailPattern.test(email);

    if (isValid) {
      this.publicSubscriberService.findEmailDuplicates(email).subscribe({
        next: (duplicateCount) => {
          const mailCount = duplicateCount.data;
          if (mailCount > 0) {
            this.newsletterForm.controls.email.setErrors({
              duplicate: true,
            });
          }
        },
      });
    }
  }
}
